module.exports = __webpack_public_path__ + "static/img/15.e3c74e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/15.png
// module id = dMZz
// module chunks = 0